import { render, staticRenderFns } from "./CardPriceTag.vue?vue&type=template&id=08e7bca8"
import script from "./CardPriceTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardPriceTag.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports